export const getRelativeDate = (dateInput) => {
    if (!dateInput) return null;

    const targetDate = new Date(dateInput);
    const now = new Date();

    // Validar fecha
    if (isNaN(targetDate.getTime())) return null;

    const diffInSeconds = Math.floor((now - targetDate) / 1000);
    const diffInHours = Math.floor(diffInSeconds / 3600);

    // 1. Si fue hace menos de 24 horas
    if (diffInSeconds >= 0 && diffInSeconds < 86400) {
        if (diffInHours < 1) {
            const mins = Math.floor(diffInSeconds / 60);
            return mins <= 1 ? "Hace un momento" : `Hace ${mins} minutos`;
        }
        return diffInHours === 1 ? "Hace 1 hora" : `Hace ${diffInHours} horas`;
    }

    // 2. Lógica de días (Ayer vs Fecha completa)
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);

    // Comparar solo fechas (sin horas)
    const isSameDay = (d1, d2) =>
        d1.getDate() === d2.getDate() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getFullYear() === d2.getFullYear();

    if (isSameDay(targetDate, now)) return "Hoy"; // Por si la hora es futura pero el día es hoy
    if (isSameDay(targetDate, yesterday)) return "Ayer";

    // 3. Formato DD/MM/YYYY para fechas más antiguas
    const day = String(targetDate.getDate()).padStart(2, '0');
    const month = String(targetDate.getMonth() + 1).padStart(2, '0');
    const year = targetDate.getFullYear();

    return `${day}/${month}/${year}`;
};